export const sortSummaries = (summaries: any[], sortedBy: string) => {
  const compareValues = (a: any, b: any) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  return summaries.slice().sort((a: any, b: any) => {
    switch (sortedBy) {
      case 'name':
        return compareValues(a.name.toLowerCase(), b.name.toLowerCase());
      case 'status':
        return compareValues(a.isPublished, b.isPublished);
      case 'publishDate':
        return compareValues(a.publishDate, b.publishDate);
      case 'updatedBy':
        return compareValues(
          a.updatedBy.toLowerCase(),
          b.updatedBy.toLowerCase(),
        );
      case 'lastUpdated':
        return compareValues(a.lastUpdated, b.lastUpdated);
      case 'isSuperPOCTool':
        return compareValues(a.isSuperPOCTool, b.isSuperPOCTool);

      default:
        return 0;
    }
  });
};
